// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.innovative-subscription-page {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    font-family: 'Arial', sans-serif;
  }
  
  header {
    text-align: center;
    margin-bottom: 30px;
  }
  
  .subscription-plans {
    display: flex;
    justify-content: space-around;
    gap: 20px;
  }
  
  .subscription-plan {
    background-color: #f5f5f5;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    text-align: center;
  }
  
  .subscription-plan h3 {
    color: #333;
  }
  
  .subscription-plan p {
    color: #777;
  }
  
  .subscription-plan ul {
    list-style-type: none;
    padding: 0;
  }
  
  .subscription-plan li {
    margin-bottom: 5px;
  }
  
  .subscription-plan button {
    background-color: #4caf50;
    color: #fff;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .subscription-plan button:hover {
    background-color: #45a049;
  }
  
  .innovative-feature {
    margin-top: 50px;
    text-align: center;
  }
  
  .innovative-feature h2 {
    color: #333;
  }
  
  .innovative-feature p {
    color: #777;
  }
  
  .innovative-feature img {
    max-width: 100%;
    border-radius: 8px;
    margin-top: 20px;
  }


  .plan-price {
    font-size: 40px;  /* Adjust the size of the h1 element */
    font-weight: 400;
  font-family: 'DM Serif Display';
  text-align: center;
  }
  @media (max-width: 768px) {
    .plan-price {
        font-size: 30px; /* Smaller font size for screens under 768px */
    }
}
  
  .text-muted {
    font-size: 20px;  /* Adjust the size of the text-muted span */
font-family: 'Lato';
  }

  .abonner{
      border: 2px solid #D6A77A !important;
      background-color: #D6A77A !important;
      color: rgb(255, 255, 255) !important;
      padding: 10px 28px !important;
      font-size: 18px !important;
      cursor: pointer !important;
      border-radius: 40px !important;
      transition: background-color 0.3s ease-in-out;
      font-family: 'Lato';
  }

  .abonner:hover {
    border: 2px solid #C9BAAC !important;
    background-color: #C9BAAC !important;
    color: #ffffff !important;
    font-size: 18px !important;
    cursor: pointer !important;
    border-radius: 40px !important;
    transition: background-color 0.3s ease-in-out;
    font-family: 'Lato';
}

  .parent-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
  
  .subscription-card {
    flex: 1 1;
    margin: 10px; /* Adjust margin as needed */
  }
  .subscription-details{
    background-repeat: no-repeat;
    background-position: center;
    padding: 50px
  }

@media (max-width: 768px) {
  .subscription-details{
    background-repeat: no-repeat;
    background-position: center;
    padding: 50px 35px;
    background-size: contain;
  }
}
  
.card-title-abonner{
  font-family: 'DM Serif Display';
}
 
.abonner-description{
  color: #2E2E2E;
  text-align: Left; 
  padding: 30px 0 20px 0;
  font-size: 14px;
  font-family: 'Lato';
  line-height: 23px;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Home/Pages/SubscriptionsPage/Subscriptions/Components/SubscriptionCard/SubscriptionCard.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,SAAS;EACX;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,uCAAuC;IACvC,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;;EAGA;IACE,eAAe,GAAG,sCAAsC;IACxD,gBAAgB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB;EACA;IACE;QACI,eAAe,EAAE,8CAA8C;IACnE;AACJ;;EAEE;IACE,eAAe,GAAG,2CAA2C;AACjE,mBAAmB;EACjB;;EAEA;MACI,oCAAoC;MACpC,oCAAoC;MACpC,oCAAoC;MACpC,6BAA6B;MAC7B,0BAA0B;MAC1B,0BAA0B;MAC1B,8BAA8B;MAC9B,6CAA6C;MAC7C,mBAAmB;EACvB;;EAEA;IACE,oCAAoC;IACpC,oCAAoC;IACpC,yBAAyB;IACzB,0BAA0B;IAC1B,0BAA0B;IAC1B,8BAA8B;IAC9B,6CAA6C;IAC7C,mBAAmB;AACvB;;EAEE;IACE,aAAa;IACb,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,SAAO;IACP,YAAY,EAAE,4BAA4B;EAC5C;EACA;IACE,4BAA4B;IAC5B,2BAA2B;IAC3B;EACF;;AAEF;EACE;IACE,4BAA4B;IAC5B,2BAA2B;IAC3B,kBAAkB;IAClB,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB","sourcesContent":[".innovative-subscription-page {\n    max-width: 800px;\n    margin: 0 auto;\n    padding: 20px;\n    font-family: 'Arial', sans-serif;\n  }\n  \n  header {\n    text-align: center;\n    margin-bottom: 30px;\n  }\n  \n  .subscription-plans {\n    display: flex;\n    justify-content: space-around;\n    gap: 20px;\n  }\n  \n  .subscription-plan {\n    background-color: #f5f5f5;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    text-align: center;\n  }\n  \n  .subscription-plan h3 {\n    color: #333;\n  }\n  \n  .subscription-plan p {\n    color: #777;\n  }\n  \n  .subscription-plan ul {\n    list-style-type: none;\n    padding: 0;\n  }\n  \n  .subscription-plan li {\n    margin-bottom: 5px;\n  }\n  \n  .subscription-plan button {\n    background-color: #4caf50;\n    color: #fff;\n    padding: 10px 20px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n  }\n  \n  .subscription-plan button:hover {\n    background-color: #45a049;\n  }\n  \n  .innovative-feature {\n    margin-top: 50px;\n    text-align: center;\n  }\n  \n  .innovative-feature h2 {\n    color: #333;\n  }\n  \n  .innovative-feature p {\n    color: #777;\n  }\n  \n  .innovative-feature img {\n    max-width: 100%;\n    border-radius: 8px;\n    margin-top: 20px;\n  }\n\n\n  .plan-price {\n    font-size: 40px;  /* Adjust the size of the h1 element */\n    font-weight: 400;\n  font-family: 'DM Serif Display';\n  text-align: center;\n  }\n  @media (max-width: 768px) {\n    .plan-price {\n        font-size: 30px; /* Smaller font size for screens under 768px */\n    }\n}\n  \n  .text-muted {\n    font-size: 20px;  /* Adjust the size of the text-muted span */\nfont-family: 'Lato';\n  }\n\n  .abonner{\n      border: 2px solid #D6A77A !important;\n      background-color: #D6A77A !important;\n      color: rgb(255, 255, 255) !important;\n      padding: 10px 28px !important;\n      font-size: 18px !important;\n      cursor: pointer !important;\n      border-radius: 40px !important;\n      transition: background-color 0.3s ease-in-out;\n      font-family: 'Lato';\n  }\n\n  .abonner:hover {\n    border: 2px solid #C9BAAC !important;\n    background-color: #C9BAAC !important;\n    color: #ffffff !important;\n    font-size: 18px !important;\n    cursor: pointer !important;\n    border-radius: 40px !important;\n    transition: background-color 0.3s ease-in-out;\n    font-family: 'Lato';\n}\n\n  .parent-container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-around;\n  }\n  \n  .subscription-card {\n    flex: 1;\n    margin: 10px; /* Adjust margin as needed */\n  }\n  .subscription-details{\n    background-repeat: no-repeat;\n    background-position: center;\n    padding: 50px\n  }\n\n@media (max-width: 768px) {\n  .subscription-details{\n    background-repeat: no-repeat;\n    background-position: center;\n    padding: 50px 35px;\n    background-size: contain;\n  }\n}\n  \n.card-title-abonner{\n  font-family: 'DM Serif Display';\n}\n \n.abonner-description{\n  color: #2E2E2E;\n  text-align: Left; \n  padding: 30px 0 20px 0;\n  font-size: 14px;\n  font-family: 'Lato';\n  line-height: 23px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
